import React from 'react';
import * as C from "../componentsM/index"
import { Accordion } from "flowbite-react";

const Curriculum = () => {


    const content = new getContent()


    return (
        <>

            <C.Hero title={"CURRICULUM"}
                image={"/hero/10.jpg"} />


            <section className='p-4 md:p-24'>

                <div className='flex flex-col gap-5'>



                    <p>There are six transdisciplinary themes which form the globally-minded focus, developed by our teaching team at each grade level. These themes are central to the PYP  philosophy. The themes are defined by the IB:</p>




                    <Accordion collapseAll className='border-0'>


                        {content.accordionData.map((v, i) => <Accordion.Panel key={i}>
                            <Accordion.Title>{v.title}</Accordion.Title>
                            <Accordion.Content className='bg-white'>
                                <p className="mb-2 text-gray-500 dark:text-gray-400">
                                    {v.content}
                                </p>
                            </Accordion.Content>
                        </Accordion.Panel>)}


                    </Accordion>


                </div>


            </section>

        </>
    )
}

export default Curriculum




class getContent {

    accordionData = [
        {
            title: "Who we are",
            content: "Enquiry into the nature of the self; beliefs and values; personal, physical, mental, social and spiritual health; human relationships including families, friends, communities, and cultures; rights and responsibilities; what it means to be human."
        },
        {
            title: "Where we are in place and time",
            content: "Enquiry into orientation in place and time; personal histories; homes and journeys; the discoveries, explorations and migrations of humankind; the relationship between and the interconnectedness of individuals and civilisations, from local and global perspectives."
        },
        {
            title: "How we express ourselves",
            content: "Enquiry into the ways in which we discover and express ideas, feelings, nature, culture, beliefs and values; the ways in which we reflect on, extend and enjoy our creativity; our appreciation of the aesthetic."
        },
        {
            title: "How the world works",
            content: "Enquiry into the natural world and its laws, the interaction between the natural world (physical and biological) and human societies; how humans use their understanding of scientific principles; the impact of scientific and technological advances on society and on the environment."
        },
        {
            title: "How we organise ourselves",
            content: "Enquiry into the interconnectedness of human-made systems and communities; the structure and function of organisations; societal decision-making; economic activities and their impact on humankind and the environment."
        },
        {
            title: "Sharing the planet",
            content: "Enquiry into rights and responsibilities in the struggle to share finite resources with other people and other living things; communities and the relationship within and between them; access to equal opportunities; peace and conflict resolution."
        },
        {
            title: "",
            content: "Each theme is addressed each year by all students. (Students aged 3 to 5 engage with four of the themes each year). In addition all PYP students have the opportunity to learn more than one language from the age of five. The PYP definition of curriculum comprises of three interrelated components. These three components are expressed in the form of the following open-ended questions:"
        },
        {
            title: "What do we want to learn?",
            content: "The written curriculum - The identification of student learning within a curriculum framework"
        },
        {
            title: "How best will we learn?",
            content: "The taught curriculum - The theory and application of good classroom practices"
        },
        {
            title: "How will we know what we have learned?",
            content: "The learned curriculum - The theory and application of effective assessment"
        }
    ];




}